import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-view-referral-history-admin',
  templateUrl: './view-referral-history-admin.component.html',
  styleUrls: ['./view-referral-history-admin.component.css']
})
export class ViewReferralHistoryAdminComponent implements OnInit {

  config: any;
  collection: any;
  term: string;
  p: number = 1;
  constructor(public admin: AdminServicesService,
    public toastr: ToastrService,
    private SpinnerService: NgxSpinnerService) {

    // //Create dummy data
    // for (var i = 0; i < this.collection.count; i++) {
    //   this.collection.data.push(
    //     {
    //       id: i + 1,
    //       value: "items number " + (i + 1)
    //     }
    //   );
    // }

    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      // totalItems: this.collection.id
    };
  }

  ngOnInit() {
    this.SpinnerService.show();
    this.admin.contactus().subscribe((res: any) => {
      this.SpinnerService.hide();
      if (res.code === 200) {
        this.collection = res.data;
      } else {
        console.log(res.message);
      }
    }, (err) => {
      console.log(err);
    });
  }
  pageChanged(event) {
    this.config.currentPage = event;
  }
}
